
try {
  var BaseCrud = require("@/classes/metadmin/basecrud").default;
} catch (err) {
  var BaseCrud = require("@/framework/classes/metadmin/basecrud").default;
}



export default class extends BaseCrud{

    constructor(module, lista, params, post, othis){
        super(module, lista, params, post, othis)

    }
}
  